<app-loading *ngIf="contentReady"></app-loading>

<div class="bg-light" style="margin-bottom: 80px;">
  <div class="container-fluid">
    <div class="row justify-content-center">

      <div class="col-12 filter-title-wrap">
        <h4 class="filter-title">{{ "shopbycatagory" | transloco }}</h4>
      </div>

      <div class="scroll-menu-new filter-menu brands-like-menu">

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === null"
          (click)="selectCategory(null)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/35.webp" alt="all">
            </div>
          </div>
          <p class="brand-card-name">{{ "all" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 0" (click)="selectCategory(0)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/18.webp" alt="soft food">
            </div>
          </div>
          <p class="brand-card-name">{{ "soft food" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 1" (click)="selectCategory(1)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/17.webp" alt="soft food can">
            </div>
          </div>
          <p class="brand-card-name">{{ "soft food can" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 2" (click)="selectCategory(2)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/23.webp" alt="dry food">
            </div>
          </div>
          <p class="brand-card-name">{{ "dry food" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 3" (click)="selectCategory(3)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/31.webp" alt="bird food">
            </div>
          </div>
          <p class="brand-card-name">{{ "bird food" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 4" (click)="selectCategory(4)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/29.webp" alt="medicine">
            </div>
          </div>
          <p class="brand-card-name">{{ "medicine" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 5" (click)="selectCategory(5)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/27.webp" alt="supplement">
            </div>
          </div>
          <p class="brand-card-name">{{ "supplement" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 6" (click)="selectCategory(6)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/26.webp" alt="accessories">
            </div>
          </div>
          <p class="brand-card-name">{{ "accessories" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 7" (click)="selectCategory(7)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/24.webp" alt="toy">
            </div>
          </div>
          <p class="brand-card-name">{{ "toy" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 8" (click)="selectCategory(8)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/25.webp" alt="grooming">
            </div>
          </div>
          <p class="brand-card-name">{{ "grooming" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 9" (click)="selectCategory(9)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/28.webp" alt="house">
            </div>
          </div>
          <p class="brand-card-name">{{ "house" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 10" (click)="selectCategory(10)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/30.webp" alt="care">
            </div>
          </div>
          <p class="brand-card-name">{{ "care" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 11" (click)="selectCategory(11)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/32.webp" alt="treats">
            </div>
          </div>
          <p class="brand-card-name">{{ "treats" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 12" (click)="selectCategory(12)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/19.webp" alt="training pads">
            </div>
          </div>
          <p class="brand-card-name">{{ "training pads" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 13" (click)="selectCategory(13)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/34.webp" alt="bags">
            </div>
          </div>
          <p class="brand-card-name">{{ "bags" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 14" (click)="selectCategory(14)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/33.webp" alt="cleaning tools">
            </div>
          </div>
          <p class="brand-card-name">{{ "cleaning tools" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card" [class.active]="activeCategory === 15" (click)="selectCategory(15)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img src="/assets/e-commerce/icons/20.webp" alt="litter">
            </div>
          </div>
          <p class="brand-card-name">{{ "litter" | transloco }}</p>
        </div>

      </div>

      <div class="scroll-menu-new limit-tags-menu brands-like-menu">

        <div class="scroll-item filter-brand-card limit-brand-card" [class.active]="activeLimit === 50"
          (click)="selectLimit(50)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img class="limit-tag-icon" src="/assets/e-commerce/icons/56.webp" alt="under 50">
            </div>
          </div>
          <p class="brand-card-name">{{ "products under 50 egp" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card limit-brand-card" [class.active]="activeLimit === 100"
          (click)="selectLimit(100)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img class="limit-tag-icon" src="/assets/e-commerce/icons/58.webp" alt="under 100">
            </div>
          </div>
          <p class="brand-card-name">{{ "products under 100 egp" | transloco }}</p>
        </div>

        <div class="scroll-item filter-brand-card limit-brand-card" [class.active]="activeLimit === 200"
          (click)="selectLimit(200)">
          <div class="brand-visual">
            <div class="brand-circle"></div>
            <div class="brand-img-wrap">
              <img class="limit-tag-icon" src="/assets/e-commerce/icons/57.webp" alt="under 200">
            </div>
          </div>
          <p class="brand-card-name">{{ "products under 200 egp" | transloco }}</p>
        </div>

      </div>

      @if (noData) {
      <app-nodata></app-nodata>
      <app-allbrands></app-allbrands>
      <app-productmostsales></app-productmostsales>
      } @else {
      <div class="row" style="padding: 0;">

        <div class="col-6">
          <h4>{{ "allproducts" | transloco }}</h4>
        </div>

        <div class="col-6 text-align" style="margin-top: 5px;">
          <p>{{ stockTotal }} {{ "Product" | transloco }}</p>
        </div>

        <app-product *ngFor="let element of allData" class="col-6 col-md-4 pointer" [element]="element" [isAr]="isAr"
          [bybrand]="true">
        </app-product>

      </div>

      <app-productmostsales *ngIf="page >= totalItems + 1 && allData.length != 0"></app-productmostsales>
      }

    </div>
  </div>
</div>